'use client';
import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { Global, Star1 } from 'iconsax-react';

interface StickyNavProps {
    ctaId?: string | undefined;
    ctaButton?: string | undefined;
    faName?: string | undefined;
}

const StickyNav = ({ ctaId, ctaButton, faName }: StickyNavProps) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 150) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleScrollToComments = () => {
        const commentSection = document.getElementById('comments');
        if (commentSection) {
            commentSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <nav
            // The Tether Chand banner floats above this bar on desktop instead of covering its buttons.
            data-banner-bottom-anchor=''
            className={`sticky border-t bg-white dark:border-progress/50 inset-x-0 dark:bg-primary-dark lg:gap-x-4 justify-center ${
                isVisible ? 'bottom-0' : '-bottom-1/2'
            } z-10 p-2 transition-all duration-300 lg:flex grid grid-cols-2`}
        >
            <Link
                className={
                    'bg-progress text-white py-2 px-4 lg:px-8 justify-center rounded-lg w-full lg:w-fit text-sm flex items-center gap-3'
                }
                id={ctaId || ''}
                rel={'nofollow'}
                href={ctaButton || '#'}
                target={'_blank'}
            >
                <Global size={'22'} className={'stroke-white'} />
                سایت اصلی
            </Link>
            <button
                onClick={handleScrollToComments}
                aria-label='scroll to comment section'
                className={'flex text-xs gap-2 justify-center items-center cursor-pointer'}
            >
                <Star1 size={'22'} className={'stroke-primary dark:stroke-white'} />
                <div className={'flex flex-col justify-center text-primary/50 dark:text-white/60'}>
                    <span>نوشتن نظر در مورد</span>
                    <span className='text-primary/90 dark:text-white/90'>{faName}</span>
                </div>
            </button>
        </nav>
    );
};

export default StickyNav;
